import React, { useMemo, useState } from "react";
import styled from "styled-components";
import "./App.css";
import background from "./assets/background/bg02.png";
import step1Bg from "./assets/desktop_step1_bg.png";
import step1Icon from "./assets/01bg_icon.png";
import levelBg from "./assets/background/bg.jpg";
import disableBtn from "./assets/button/ok_off.png";
import btn from "./assets/button/ok_in.png";
import LevelBlock from "./LevelBlock";
import Modal from "react-modal";
import {
  state,
  setLevel1,
  setLevel2,
  setLevel3,
  setLevel4,
  setLevel5,
  setLevel6,
  setLevel7,
  changeInput,
  canComplete,
  setCompleteImage,
  setStep,
} from "./features/gameSlice";
import { useAppSelector, useAppDispatch } from "./app/hooks";
import mergeImages from "merge-images";
import { generate } from "text-to-image";
import ImageMap, { IconMap } from "./ImageMap";
import Complete from "./DesktopComplete";
import level1_title from "./assets//A_title.png";
import level2_title from "./assets/AA_title.png";
import level3_title from "./assets/C_title.png";
import level4_title from "./assets/B_title.png";
import level5_title from "./assets/D_title.png";
import level6_title from "./assets/E_title.png";
import level7_title from "./assets/all_name_title.png";
import finishIcon from "./assets/addok.png";
import popupTitle from "./assets/all_name_title.png";
import popupHint from "./assets/name_imp.png";
import popupOK from "./assets/OK.png";
import popupClose from "./assets/xx.png";
import okBg from "./assets/ok_bg.jpg";
import logo from "./assets/museum_logo.png";

const ImageContainer = styled.div<{ image: string }>`
  background: url(${(props) => props.image});
  background-size: contain;
  background-repeat: no-repeat;
`;

const PopupImage = styled(ImageContainer)`
  width: 210px;
  height: 60px;
`;

const Bg = styled(ImageContainer)`
  height: 100vh;
  width: 100vw;
  background-size: cover;
  display: flex;
`;

const Step1Bg = styled(Bg)`
  width: 100vw;
  height: 160px;
  background-size: cover;
`;

const LevelBg = styled.div`
  height: 100vh;
  background: url(${levelBg});
  width: 55vh;
  max-width: 600px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  position: relative;
`;
const LevelTitle = styled(ImageContainer)`
  height: 75px;
  width: 262px;
  margin-right: 9px;
`;

const Level7Title = styled(LevelTitle)`
  margin-left: 9px;
  margin-right: 0px;
`;

const CompleteButton = styled.div<{ disabled: boolean }>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  height: 11%;
  width: 100%;
  bottom: 0;
  position: absolute;
  background: url(${({ disabled }) => (disabled ? disableBtn : btn)});
  background-size: contain;
  background-repeat: no-repeat;
`;

const IconBtn = styled(ImageContainer)`
  height: 75px;
  width: 75px;
`;

const FinishHint = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 19px;
  height: 19px;
  background: url("${finishIcon}");
  background-size: cover;
`;

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  align-items: center;
`;

const CustomInput = styled.input`
  max-width: 192px;
  height: 40px;
  font-size: 20px;
`;

const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PopupBtn = styled(ImageContainer)`
  width: 150px;
  height: 60px;
`;

const PopupClose = styled(ImageContainer)`
  width: 20px;
  height: 20px;
`;

const Logo = styled(ImageContainer)`
  width: 350px;
  height: 62px;
  margin-bottom: 20px;
`;
const Flex = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const Step1Icon = styled(ImageContainer)`
  height: 340px;
  width: 340px;
  background-size: cover;
  display: flex;
`;

const customStyles = {
  content: {
    height: 250,
    backgroundColor: "#EEE0CB",
    margin: "auto",
  },
};

function Mobile() {
  const [isOpenModal, toggleModal] = useState(false);
  const canOK = useAppSelector(canComplete);
  const dispatch = useAppDispatch();
  const {
    completeImage,
    inputValue,
    level1,
    level2,
    level3,
    level4,
    level5,
    level6,
    level7,
    step,
  } = useAppSelector(state);

  const levelArray = useMemo(() => {
    return [
      {
        value: 1,
        image: level1,
        text: level1_title,
        action: setLevel1,
        child: ["level1_1", "level1_2", "level1_3"],
      },
      {
        value: 2,
        image: level2,
        text: level2_title,
        action: setLevel2,
        child: ["level2_1", "level2_2", "level2_3", "level2_4", "level2_5"],
      },
      {
        value: 3,
        image: level3,
        text: level3_title,
        action: setLevel3,
        child: ["level3_1", "level3_2", "level3_3", "level3_4", "level3_5"],
      },
      {
        value: 4,
        image: level4,
        text: level4_title,
        action: setLevel4,
        child: ["level4_1", "level4_2", "level4_3", "level4_4", "level4_5"],
      },
      {
        value: 5,
        image: level5,
        text: level5_title,
        action: setLevel5,
        child: ["level5_1", "level5_2", "level5_3", "level5_4", "level5_5"],
      },
      {
        value: 6,
        image: level6,
        text: level6_title,
        action: setLevel6,
        child: ["level6_1", "level6_2", "level6_3", "level6_4", "level6_5"],
      },
    ];
  }, [level1, level2, level3, level4, level5, level6]);

  const completeAction = async () => {
    const array = [
      { src: okBg },
      { src: ImageMap[`${level1}_${level2}`], x: 50 },
      { src: ImageMap[level4], x: 50 },
      { src: ImageMap[level3], x: 50 },
      { src: ImageMap[level5], x: 50 },
      { src: ImageMap[level6], x: 50 },
      { src: level7, x: 50 },
    ];
    if (!level7) {
      array.pop();
    }

    try {
      const finishb64 = await mergeImages(array);

      dispatch(setCompleteImage(finishb64));
      dispatch(setStep(3));
    } catch (err) {
      console.log(err);
    }
  };
  switch (step) {
    case 1:
      return (
        <div
          style={{
            background: "rgb(240, 230, 210)",
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          onClick={() => {
            dispatch(setStep(2));
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Step1Icon image={step1Icon} />
          </div>
          <Step1Bg image={step1Bg}></Step1Bg>

          <Logo image={logo}></Logo>
        </div>
      );
    case 2:
      return (
        <Bg image={background}>
          <LevelBg>
            <LevelBlock />
            <CompleteButton
              disabled={!canOK}
              onClick={completeAction}
            ></CompleteButton>
          </LevelBg>
          <IconContainer>
            <div style={{ padding: "20px 0px" }}>
              {levelArray.map((el) => (
                <Flex>
                  <LevelTitle image={el.text} />
                  {el.child.map((child) => (
                    <div style={{ position: "relative" }}>
                      {el.image === child && <FinishHint />}
                      <IconBtn
                        key={el.value}
                        image={IconMap[child]}
                        onClick={() => {
                          dispatch(el.action(child));
                        }}
                      />
                    </div>
                  ))}
                </Flex>
              ))}
              <div style={{ position: "relative", display: "flex" }}>
                <Level7Title image={level7_title} />
                <div style={{ position: "relative" }}>
                  {inputValue && <FinishHint />}
                  <IconBtn
                    image={IconMap["level7_1"]}
                    onClick={() => {
                      toggleModal(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </IconContainer>
          <Modal isOpen={isOpenModal} style={customStyles}>
            <PopupClose
              image={popupClose}
              onClick={() => {
                toggleModal(false);
              }}
            />
            <PopupContainer>
              <PopupImage image={popupTitle} />
              <CustomInput
                maxLength={5}
                value={inputValue}
                onChange={(e) => {
                  dispatch(changeInput(e.target.value));
                }}
              />
              <PopupImage image={popupHint} />

              <PopupBtn
                image={popupOK}
                onClick={async () => {
                  const dataUri = await generate(inputValue, {
                    bgColor: "transparent",
                    textAlign: "center",
                    fontSize: 30,
                    maxWidth: 600,
                  });

                  const finishb64 = await mergeImages(
                    [{ src: dataUri, y: 524 }],
                    {
                      width: 600,
                      height: 1080,
                    }
                  );

                  dispatch(setLevel7(finishb64));
                  toggleModal(false);
                }}
              />
            </PopupContainer>
          </Modal>
        </Bg>
      );
    case 3:
      return <Complete image={completeImage} />;
    default:
      return null;
  }
}

export default Mobile;
